import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import {
  ProductionRouteMatchResult,
  ScheduleMismatchReason,
  ScheduleStep,
  WorkItemSchedule,
  WorkItemScheduleMatchResult,
} from '../work-item-schedule'
import { MatTooltip } from '@angular/material/tooltip'
import { AsyncPipe } from '@angular/common'
import { ElderTranslateService } from '@elderbyte/ngx-starter'

@Component({
  selector: 'app-item-schedule',
  templateUrl: './work-item-schedule.component.html',
  styleUrls: ['./work-item-schedule.component.scss'],
  imports: [MatTooltip, AsyncPipe],
})
export class WorkItemScheduleComponent {
  private translate = inject(ElderTranslateService)

  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly route$ = new BehaviorSubject<WorkItemSchedule>(null)

  public readonly ScheduleMismatchReason = ScheduleMismatchReason

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set route(route: WorkItemSchedule) {
    this.route$.next(route)
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public getSegmentClass(segment: ScheduleStep): string {
    return segment.matchResult?.mismatchReasons?.length > 0 ? 'segment-unavailable' : 'segment'
  }

  public getToolTip(matchResult: WorkItemScheduleMatchResult): string {
    if (matchResult && matchResult?.mismatchReasons?.length > 0) {
      if (matchResult?.mismatchReasons?.includes(ScheduleMismatchReason.CONSTRAINT)) {
        return this.getConstraintMismatchMessage(matchResult?.prodRouteMatchResult)
      } else {
        return this.translate.instant(
          'ScheduleMatchResultMismatchReason.' + matchResult?.mismatchReasons[0]
        ) // Get most severe
      }
    }

    return ''
  }

  private getConstraintMismatchMessage(prodRouteMatchResult: ProductionRouteMatchResult): string {
    let msg = ''

    const constraintMatch = prodRouteMatchResult?.constraintMatchResult

    if (constraintMatch && !constraintMatch?.matches) {
      const constraint = constraintMatch?.constraint
      msg += this.translate.instant('skillSets.constraints.violated') + ': '
      msg += constraint?.property?.description + ' '
      msg += constraintMatch?.inputValue + ' '
      msg += this.translate.instant('ConstraintOperator.' + constraint?.operator) + ' '
      msg += constraint?.values + ' '

      const unit = constraint?.property?.unit
      if (unit) {
        msg += unit
      }
    }

    return msg
  }
}
